import { render, staticRenderFns } from "./SpaceFormLayout.vue?vue&type=template&id=084ed7a9"
import script from "./SpaceFormLayout.vue?vue&type=script&lang=js"
export * from "./SpaceFormLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports